import { useEffect } from "react";

export default function WatiWidget() {
  useEffect(() => {
    const script = document.createElement("script");
    script.src =
      "https://wati-integration-prod-service.clare.ai/v2/watiWidget.js?86624";
    script.async = true;

    script.onload = () => {
        const options = {
        enabled: true,
        chatButtonSetting: {
            backgroundColor: "#3a2a00", // Official WhatsApp green
            ctaText: "",
            borderRadius: "50",
            marginLeft: "0",
            marginRight: "20",
            marginBottom: "70",
            ctaIconWATI: false,
            position: "right",
        },
        brandSetting: {
            brandName: "Highend Holidays Homes",
            brandSubTitle: "Online",
            brandImg:
            "./assets/logo.png",
            welcomeText: "👋 Hi there! How can we assist you today?",
            messageText: "Hello, I have a question about {{page_link}}",
            backgroundColor: "#3a2a00", // WhatsApp header color
            ctaText: "Start Chat",
            borderRadius: "10",
            autoShow: false,
            phoneNumber: "971505069469",
        },
        };


      // Create widget
      window.CreateWhatsappChatWidget(options);
    };

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return null;
}
